// @flow
import type { AnimatableCSSProperty } from './types/css'

const speedFast = '0.15s'
const speedMedium = '0.3s'
const speedSlow = '0.7s'

const transition = speed => (
  ...properties: $ReadOnlyArray<AnimatableCSSProperty>
) => ({
  transitionProperty: properties.length ? properties.join(',') : 'all',
  transitionDuration: speed,
  transitionTimingFunction: 'cubic-bezier(0.325, -0.075, 0, 1.65)',
})

export const fast = transition(speedFast)
export const medium = transition(speedMedium)
export const slow = transition(speedSlow)



// WEBPACK FOOTER //
// ./src/style/transition.js